import classNames from 'classnames';
import type { ButtonHTMLAttributes, ReactNode } from 'react';

import styles from './UtilityButton.module.css';

export type UtilityButtonSize = 'xs' | 'sm';
export type UtilityButtonHierarchy = 'secondary' | 'tertiary';

export interface UtilityButtonProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'children'
> {
  size?: UtilityButtonSize;
  hierarchy?: UtilityButtonHierarchy;
  /** The glyph — any node (`<Icon>`, an SVG, …). */
  icon: ReactNode;
  /** Accessible name (this button is always icon-only). */
  label: string;
}

/**
 * Compact icon-only button for dense surfaces (toolbars, table row actions).
 *
 * @interim Ported from the reference design; replaceable by the UI Kit without API breakage.
 */
export function UtilityButton({
  size = 'sm',
  hierarchy = 'secondary',
  icon,
  label,
  className,
  type = 'button',
  ...rest
}: UtilityButtonProps) {
  return (
    <button
      type={type}
      aria-label={label}
      className={classNames(styles.utility, styles[`size-${size}`], styles[hierarchy], className)}
      {...rest}
    >
      <span className={styles.icon}>{icon}</span>
    </button>
  );
}
